if(!customElements.get('drawer-component')) {
  customElements.define(
    'drawer-component',
    class MenuDrawer extends HTMLElement {
      #mainSheet;
      #open;
      #header;
      #innerSheetTriggers;
      #backButtons;
      #onUpdate;
      #onResize;
      #onOpenInner;
      #onBack;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#open = false;
        this.#header = document.querySelector('#header-group');
        this.#mainSheet = this.querySelector('[data-sheet="main"]');
        this.#innerSheetTriggers = this.querySelectorAll('[data-inner]');
        this.#backButtons = this.querySelectorAll('[data-back]');

        if (!this.#header || !this.#mainSheet) return;

        this.#onUpdate = this.onUpdate.bind(this);
        this.#onResize = this.updateLayout.bind(this);
        this.#onOpenInner = this.onOpenInner.bind(this);
        this.#onBack = this.onBack.bind(this);

        window.addEventListener('update-drawer', this.#onUpdate);
        window.addEventListener('resize', this.#onResize);

        this.#innerSheetTriggers?.forEach(trigger => {
          trigger.addEventListener('click', this.#onOpenInner);
        });

        this.#backButtons?.forEach(button => {
          button.addEventListener('click', this.#onBack);
        });
        
        this.updateLayout();
      }

      disconnectedCallback() {
        window.removeEventListener('update-drawer', this.#onUpdate);
        window.removeEventListener('resize', this.#onResize);
        this.#innerSheetTriggers?.forEach(trigger => {
          trigger.removeEventListener('click', this.#onOpenInner);
        });
        this.#backButtons?.forEach(button => {
          button.removeEventListener('click', this.#onBack);
        });
      }

      onUpdate(evt) {
        this.#open = evt.detail.open;
        this.updateUI();
      }

      onOpenInner(evt) {
        const targetSheet = evt.target.getAttribute('data-inner');
        this.querySelector(`[data-sheet="${targetSheet}"]`)
          ?.classList.add('open');
      }

      onBack(evt) {
        evt.target.closest('.sheet')?.classList.remove('open');
      }

      updateLayout() {
        const headerHeight = this.#header.getBoundingClientRect().height;
        this.style.top = `${headerHeight}px`;
        this.style.height = `calc(100vh - ${headerHeight}px)`;
      }

      updateUI() {
        this.classList.toggle('show', this.#open);
        this.#mainSheet.classList.toggle('open', this.#open);
      }
    }
  );
}